import React from "react";

import { Card, Button } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import TicketHeaderSkeleton from "../TicketHeaderSkeleton";
import ArrowBackIos from "@material-ui/icons/ArrowBackIos";
import { useHistory } from "react-router-dom";
import { createInfoChatTicketHeaderStyles } from "../infoChatTicketHeaderStyles";

const useStyles = makeStyles(theme => {
	const infoChatTicketHeader = createInfoChatTicketHeaderStyles(theme);

	return {
		ticketHeader: {
			display: "flex",
			// backgroundColor: "#eee",
			backgroundColor: infoChatTicketHeader.headerSurface.backgroundColor,
			flex: "none",
			borderBottom: `1px solid ${infoChatTicketHeader.headerBorder.borderColor}`,
			height: 72,
			alignItems: "center",
			padding: theme.spacing(0, 1),
			boxShadow: "none",
			[theme.breakpoints.down("sm")]: {
				height: 64,
				padding: 0,
				alignItems: "center",
				"& > .MuiButton-root": {
					minWidth: 44,
					paddingLeft: 12,
					paddingRight: 6,
				},
			},
		},
		backButton: {
			minWidth: 40,
			borderRadius: 10,
			[theme.breakpoints.up("md")]: {
				display: "none",
			},
			"&.Mui-focusVisible": {
				outline: infoChatTicketHeader.focusRingAccent.outline,
				outlineOffset: infoChatTicketHeader.focusRingAccent.outlineOffset,
			},
		},
	};
});

const TicketHeader = ({ loading, children }) => {
	const classes = useStyles();
	const history = useHistory();

	const handleBack = () => {

		history.push("/tickets");
	};

	// useEffect(() => {
	// 	const handleKeyDown = (event) => {
	// 		if (event.key === "Escape") {
	// 			handleBack();
	// 		}
	// 	};
	// 	document.addEventListener("keydown", handleKeyDown);
	// 	return () => {
	// 		document.removeEventListener("keydown", handleKeyDown);
	// 	};
	// }, [history]);

	return (
		<>
			{loading ? (
				<TicketHeaderSkeleton />
			) : (
				<Card
					square
					className={classes.ticketHeader}
				>
					<Button className={classes.backButton} color="primary" onClick={handleBack}>
						<ArrowBackIos />
					</Button>
					{children}
				</Card>
			)}
		</>
	);
};

export default TicketHeader;
